import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import tresaTopics from "../../data/Ontario/tresaTopics.js";
import transactionTopics from "../../data/Ontario/transactionTopics.js";

export default function TRESA({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  // Add CSS for accordion content
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .accordion-content ol {
        margin-left: -15px !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const [TresaTopic, setTresaTopic] = useState("");
  const [TransactionTopic, setTransactionTopic] = useState("");
  const [expandedAccordion, setExpandedAccordion] = useState(false);
  const [selectedSection, setSelectedSection] = useState("transaction");

  const handleTresaTopic = (e) => {
    setTransactionTopic("");
    setTresaTopic(tresaTopics.filter((topic) => topic.id === e.target.value));
  };

  const handleTransactionTopic = (e) => {
    setTresaTopic("");
    setTransactionTopic(
      transactionTopics.filter((topic) => topic.id === e.target.value)
    );
    setExpandedAccordion(false);
  };

  const handleSectionChange = (e) => {
    const section = e.target.value;
    setSelectedSection(section);

    // Clear the opposite section when switching
    if (section === "transaction") {
      setTresaTopic("");
      // Simulate calling handleTransactionTopic by clearing TransactionTopic
      // The actual selection will happen when user selects from dropdown
    } else {
      setTransactionTopic("");
      setExpandedAccordion(false);
      // Simulate calling handleTresaTopic by clearing TransactionTopic
      // The actual selection will happen when user selects from dropdown
    }
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);

    // Scroll to the top of the first accordion when expanded (mobile only)
    if (isExpanded && window.innerWidth <= 768) {
      // Use a longer timeout for iOS and add multiple attempts
      const scrollToFirstAccordion = () => {
        // Try multiple selectors to find the first accordion
        const firstAccordion =
          document.querySelector('[data-testid="accordion-0"]') ||
          document.querySelector(".MuiAccordion-root") ||
          document.querySelector('[role="region"]');

        if (firstAccordion) {
          try {
            // Get the position and add offset to position just below header
            const rect = firstAccordion.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80; // 80px offset to position below header

            // Use requestAnimationFrame for smoother scrolling on iOS
            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          } catch (error) {
            // Error scrolling to first accordion
          }
        } else {
          // Fallback: try to scroll to the Property/Transaction Type container
          const transactionContainer = document.querySelector(".max-w-4xl");
          if (transactionContainer) {
            const rect = transactionContainer.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80;

            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          }
        }
      };

      // First attempt after a longer delay for iOS
      setTimeout(scrollToFirstAccordion, 600);

      // Second attempt as backup for iOS
      setTimeout(scrollToFirstAccordion, 1000);
    }
  };

  useEffect(() => {
    setProvince("ON");
  });

  return (
    <div className="w-full  mt-5 flex flex-col justify-center items-left">
      <div>
        <h1>General TRESA Training</h1>
        <p>
          To learn about the TRESA legislation please visit the following
          resources:
          <br />
          <br />
          <a
            href="https://www.reco.on.ca/agents-and-brokerages/tresa-explained/ce-course-introduction-to-tresa"
            target="_blank"
            rel="noreferrer"
          >
            RECO TRESA Update Course
          </a>
          &nbsp;(Mandatory for New Agents)
          <br />
          <a
            href="https://www.reco.on.ca/agents-and-brokerages/tresa-explained/reco-bulletins"
            target="_blank"
            rel="noreferrer"
          >
            RECO Bulletins
          </a>
          <br />
          <a
            href="https://drive.google.com/drive/folders/1dFtlupzqycBmX9X1X9b3vNcEfX55eNtd"
            target="_blank"
            rel="noreferrer"
          >
            eXp TRESA Overview Training
          </a>
        </p>

        <br />
      </div>
      <ThemeProvider theme={theme}>
        <h1 className=" mt-4 ">Transaction Best Practices</h1>
        <p></p>
        <FormControl sx={{ ml: 2, mt: 1, mb: 2 }}>
          <RadioGroup
            row
            value={selectedSection}
            onChange={handleSectionChange}
            aria-labelledby="section-radio-buttons-group-label"
            name="section-radio-buttons-group"
          >
            <FormControlLabel
              value="transaction"
              control={<Radio size="small" />}
              label="Transaction Type: Common Due Diligences"
            />
            <FormControlLabel
              value="tresa"
              control={<Radio size="small" />}
              label="TRESA Topics"
            />
          </RadioGroup>
        </FormControl>
      </ThemeProvider>
      {selectedSection === "tresa" && (
        <div className="flex flex-col pb-3">
          <ThemeProvider theme={theme}>
            <FormControl
              sx={{
                ml: 2,
                mt: 1,
                mb: 1,
                minWidth: 360,
                maxWidth: 360,
              }}
            >
              <InputLabel size="small" className="select-default-label">
                TRESA Topic
              </InputLabel>
              <Select
                value={TresaTopic === "" ? "" : TresaTopic[0]?.id || ""}
                name="TRESA Topic"
                label="TRESA Topic"
                onChange={handleTresaTopic}
                size="small"
                sx={{ borderRadius: 20 }}
                defaultValue={""}
              >
                <MenuItem
                  key={Math.random()}
                  value="SRP"
                  style={{ whiteSpace: "normal" }}
                >
                  Self Represented Party
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="DesigRepForms"
                  style={{ whiteSpace: "normal" }}
                >
                  Designated Representation Forms
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="RECOGuide"
                  style={{ whiteSpace: "normal" }}
                >
                  RECO Information Guide
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="MultiRep"
                  style={{ whiteSpace: "normal" }}
                >
                  Multiple Representation
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="ScheduleA"
                  style={{ whiteSpace: "normal" }}
                >
                  Schedule A in Agreements
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="Lockboxes"
                  style={{ whiteSpace: "normal" }}
                >
                  Lockbox Authorization & Consent
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="LatentDefects"
                  style={{ whiteSpace: "normal" }}
                >
                  Disclosure of Latent Defects
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="OpenHouses"
                  style={{ whiteSpace: "normal" }}
                >
                  Open Houses
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="SharingContent"
                  style={{ whiteSpace: "normal" }}
                >
                  Sharing Contents of Offers
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
        </div>
      )}
      {selectedSection === "transaction" && (
        <div className="flex flex-col">
          <ThemeProvider theme={theme}>
            <FormControl
              sx={{
                ml: 2,
                mt: 1,
                mb: 1,
                minWidth: 360,
                maxWidth: 360,
              }}
            >
              <InputLabel size="small" className="select-default-label">
                Property/Transaction Type
              </InputLabel>
              <Select
                value={
                  TransactionTopic === "" ? "" : TransactionTopic[0]?.id || ""
                }
                name="Property/Transaction Type"
                label="Property/Transaction Type"
                onChange={handleTransactionTopic}
                size="small"
                sx={{ borderRadius: 20 }}
                defaultValue={""}
              >
                <MenuItem
                  key={Math.random()}
                  value="singleFamily"
                  style={{ whiteSpace: "normal" }}
                >
                  Single Family Residential (Resale)
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="condo"
                  style={{ whiteSpace: "normal" }}
                >
                  Residential Condo (Resale)
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="preconcondo"
                  style={{ whiteSpace: "normal" }}
                >
                  Pre-Construction (Condos)
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="FSBO"
                  style={{ whiteSpace: "normal" }}
                >
                  For Sale by Owner (Residential Resale)
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="tenantedProperty"
                  style={{ whiteSpace: "normal" }}
                >
                  Residential (Tenant - Vacant Possession)
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="mobileManufactured"
                  style={{ whiteSpace: "normal" }}
                >
                  Mobile, Manufactured, Modular Home
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="powerofsale"
                  style={{ whiteSpace: "normal" }}
                >
                  Power of Sale
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="ruralCountry"
                  style={{ whiteSpace: "normal" }}
                >
                  Rural & Country Properties
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="cooperative"
                  style={{ whiteSpace: "normal" }}
                >
                  Co-operative Residential
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="cottage"
                  style={{ whiteSpace: "normal" }}
                >
                  Cottage Property
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="assignment"
                  style={{ whiteSpace: "normal" }}
                >
                  Assignments (Pre-Construction)
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="indigenousLand"
                  style={{ whiteSpace: "normal" }}
                >
                  Reserve Land (Leased Land)
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="vacantLand"
                  style={{ whiteSpace: "normal" }}
                >
                  Vacant Land
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
        </div>
      )}
      {TransactionTopic !== "" && (
        <div className="max-w-5xl w-full flex justify-left mt-5">
          <ThemeProvider theme={theme}>
            <div className="mt-2 mb-1 max-w-5xl">
              <div className="title-header ">
                <h1>{TransactionTopic[0]?.title}</h1>
              </div>
              <div className="mt-2 mb-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: TransactionTopic[0]?.description,
                  }}
                />
              </div>
              {Array.isArray(TransactionTopic[0]?.text) ? (
                // If text is an array, map through it to create accordions
                TransactionTopic[0].text.map((section, index) => (
                  <Accordion
                    key={index}
                    data-testid={
                      index === 0 ? "accordion-0" : `accordion-${index}`
                    }
                    sx={{
                      mb: 1,
                      borderRadius: "5px 5px 0 0",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      "&:hover": {
                        boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                      },
                      "& .MuiAccordionDetails-root": {
                        padding: "24px 15px 15px 15px",
                      },
                      "&.Mui-expanded": {
                        margin: "8px 0",
                      },
                    }}
                    expanded={expandedAccordion === `panel${index}`}
                    onChange={handleAccordionChange(`panel${index}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                      aria-controls={`${TransactionTopic[0].id}-${index}-content`}
                      id={`${TransactionTopic[0].id}-${index}-header`}
                      sx={{
                        backgroundColor: "#ffffff",
                        borderBottom: "1px solid #e0e0e0",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        minHeight: "48px",
                        height: "48px",
                        "& .MuiAccordionSummary-content": {
                          margin: "8px 0",
                        },
                        "& .MuiAccordionSummary-expandIconWrapper": {
                          transform: "rotate(0deg)",
                          transition: "transform 0.2s ease-in-out",
                        },
                        "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper":
                          {
                            transform: "rotate(180deg)",
                          },
                        "&:hover": {
                          backgroundColor: "rgba(12, 15, 36, 0.1)",
                        },
                        "&.Mui-expanded": {
                          backgroundColor: "rgba(12, 15, 36, 0.1)",
                          minHeight: "48px",
                          height: "48px",
                        },
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          color: "#0c0f24",
                          fontSize: "16px",
                          fontFamily: "Manrope, sans-serif",
                        }}
                      >
                        {section.title}
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: section.text,
                        }}
                        style={{
                          lineHeight: 1.6,
                          color: "#31303F",
                        }}
                        className="accordion-content"
                      />
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                // If text is a string, show it directly
                <div className="body pt-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: TransactionTopic[0].text,
                    }}
                    style={{
                      lineHeight: 1.6,
                      color: "#31303F",
                    }}
                  />
                </div>
              )}
            </div>
          </ThemeProvider>
        </div>
      )}
      <div className="max-w-5xl w-full flex justify-left mt-7">
        {TresaTopic === "" ? (
          ""
        ) : (
          <div className="body">
            <div className="title-header ">
              <h1>{TresaTopic[0].title} </h1>
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: TresaTopic[0].text,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

/*

 <MenuItem
                key={Math.random()}
                value="preconfreehold"
                style={{ whiteSpace: "normal" }}
              >
                Pre-Construction (Freehold)
              </MenuItem>
              
               


              <MenuItem
                key={Math.random()}
                value="crownLand"
                style={{ whiteSpace: "normal" }}
              >
                Purchase on Crown Land (Leased Land)
              </MenuItem>
              
              
              */
